import { Colleague, DealRoom } from 'models/DealRoom';
import { createContext } from 'react';
import utils from 'utils';

type DealRoomContextContextProps = {
  dealRoom: DealRoom;
  colleagues: Colleague[];
  isLoading: boolean;
  areColleaguesLoading: boolean;
  updateDealRoom?: (dealRoom: Partial<DealRoom>) => void;
};

export default createContext<Partial<DealRoomContextContextProps>>({
  dealRoom: null,
  colleagues: [],
  isLoading: true,
  areColleaguesLoading: true,
  updateDealRoom: utils.noop,
});
